import { render } from "./InputAutocomplete.vue?vue&type=template&id=54935700"
import script from "./InputAutocomplete.vue?vue&type=script&lang=js"
export * from "./InputAutocomplete.vue?vue&type=script&lang=js"

import exportComponent from "/home/gaspa/Projects/coffee-jurnal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__